'use client';

import clsx from 'clsx';
import React from 'react';
import Button from '@/components/atoms/Button';
import { pushGTMEventForATM } from '@/utils/gtm';
import { ATM_DETAILS_HOW_IT_WORKS_ATM_CLICK_EVENT } from '@/utils/gtm/consts';
import { HowItWorksButtonProps } from './types';
const HowItWorksButton: React.FC<HowItWorksButtonProps> = ({
  label,
  availableCoins,
  target,
  location
}) => <Button className={clsx('order-1 col-span-2', availableCoins.sell.length ? 'lg:order-2 lg:col-span-1' : 'lg:order-4 lg:col-span-2')} variant="outline" onClick={() => {
  document.querySelector(`[data-slice-id="${target}"]`)?.scrollIntoView({
    behavior: 'smooth',
    block: 'center'
  });
  if (!location) {
    return;
  }
  pushGTMEventForATM(location, ATM_DETAILS_HOW_IT_WORKS_ATM_CLICK_EVENT);
}} data-sentry-element="Button" data-sentry-component="HowItWorksButton" data-sentry-source-file="index.tsx">
    {label}
  </Button>;
export default HowItWorksButton;